import React from "react";

const Footer: React.FC = () => {
  return (
    <section className="bg-transparent px-1 pt-1 pb-4 mt-1 md:p-4 md:mt-1 text-sm text-center">
      <p className="text-black text-sm">Standby Travel© 2026</p>
    </section>
  );
};

export default Footer;
